import {inject, Injectable} from '@angular/core';
import {
  ApisService,
  DialogService,
  NotificationService,
  ServiceFactoryService,
  TypeFactoryService
} from "@wms/services";
import {MixpanelService} from "@wms/app/services/mixpanel/mixpanel.service";
import {RestImportUiComponent} from "@wms/app/workspace/api-workspace/rest-import-ui/rest-import-ui.component";
import {BaseComponent} from "@wms/components";
import {WmsWorkspaceManagerService} from "@wms/workspace";
import {setLocalStorageItem} from "../../projects/core/src/utils/studio-user-preferences";
import {EventManagerService} from "@wms/app/event-manager";

@Injectable({
  providedIn: 'root'
})
export class ApiWorkspaceService extends BaseComponent{

  disableUpdateButton: boolean = true;
  selectedDeleteServiceType: string = ''
  swaggerDeleteMsg: any;
  deleteWebServiceName: any;
  dialogParams: { [key: string]: string };
  showRestImport: boolean = false;
  isEmptyWS: boolean = false;
  loadingApi = false;
  showGuidedTour: boolean;
  wsManager:WmsWorkspaceManagerService;
  dialogService:DialogService;
  mixpanelService: MixpanelService;

  apiService: ApisService;

  notificationService:NotificationService
  serviceFactory:ServiceFactoryService;
  typeService:TypeFactoryService;
  requestBody: any;
  responseBody: any = '';
  importDisabled: boolean = true;
  restImportServiceName: string = '';
  settingsUploadData: any;



  constructor() {
    super();
    this.apiService = inject(ApisService);
    this.dialogService= inject(DialogService);
    this.mixpanelService= inject(MixpanelService);
    this.wsManager= inject(WmsWorkspaceManagerService);
  }

  // updateRestService() {
  //   const serviceName: any = this.restImportComponentUI.restImportData.restImportServiceName();
  //   this.apiService
  //     .updateRestService(
  //       this.restImportComponentUI.restImportData.settingsUploadData(),
  //       serviceName
  //     )
  //     .then(() => {
  //       this.serviceFactory.getServiceDef(serviceName, true).then(() => {
  //         this.typeService.updateDataTypesCache(serviceName);
  //       });
  //       this.notificationService.show('success', this.locale['TITLE_WRITE_CONFIG_SUCCESS'], this.locale['MESSAGE_SUCCESS_WEB_SERVICE_REST_UPDATE'])
  //     })
  //     .catch(() => {
  //       this.notificationService.show('error', this.locale['MESSAGE_ERROR_HTTP_ERROR_TITLE'], this.locale['MESSAGE_ERROR_UPDATE_FAILED'])
  //     });
  //   this.disableUpdateButton = true
  // }

  deleteWebService($event: Event, serviceName: string, serviceType: string) {
    this.swaggerDeleteMsg = this.locale.MESSAGE_SWAGGER_DELETE.replace("${0}", serviceName);
    this.selectedDeleteServiceType = serviceType
    this.deleteWebServiceName = serviceName;
    this.dialogParams = { name: serviceName };
    this.dialogService.open('DeleteImportedApi');
    if (serviceType === 'OpenAPIService') {
      let paths =this.apiService.swaggerInfo.paths;
      this.mixpanelService.track('delete_api_bundle', {'service_id': serviceName,'endpoints_count': this.apiService.getEndpointsCount(paths,"delete")});
    }
  }

  refreshApi() {
    let activeServiceIndex = 0,
      activeApiIndex = 0;
    if (this.apiService.services.length && this.apiService.activeApi) {
      activeServiceIndex = this.getActiveServiceIndex(this.apiService.services, this.apiService.activeApi && this.apiService.activeApi.serviceId);
      activeApiIndex = this.getActiveApiIndex(this.apiService.services[activeServiceIndex].apis, this.apiService.activeApi[this.apiService.RELATIVE_PATH_KEY]);
    }
    this.apiService.activeApiHead.api.activeTag = this.apiService.activeApi['x-WM-RELATIVE_PATH'];
    this.apiService.initApiViewer(this.apiService.activeApiHead.api, true, activeServiceIndex, activeApiIndex);
  }

  getActiveServiceIndex(services: any, serviceId: any) {
    let index = 0;
    services.some((service: any, i: any) => {
      if (service.name === serviceId) {
        index = i;
        return true;
      }
      return;
    });
    return index;
  }

  getActiveApiIndex(apis: any, activeApiName: any) {
    let index = 0;
    apis.some((api: any, i: any) => {
      if (api[this.apiService.RELATIVE_PATH_KEY] === activeApiName) {
        index = i;
        return true;
      }
      return;
    });
    return index;
  }


  updateApi(refresh: boolean = true) {
    return new Promise((resolve, reject)=>{
      let params;
      // Update the swagger only when the Api Designer is dirty.
      if (this.apiService.activeApi && this.wsManager.isWSDirty()) {
        params = {
          pathParams: {
            'serviceId': this.apiService.activeApi.serviceId,
            'projectId': this.projectService.getProjectId()
          },
          data: this.apiService.tagInfoOriginal
        };
        /* Updates the controller. "response" is the changed swagger object */
        (this.apiService.updateSwagger(params) as Promise<any>).then((resp: any) => {
          /* deploy the project to be able to run the API's */
          this.loadingApi = false;
          this.wsManager.setDirtyonWs(false);
          refresh && this.refreshApi();
          resolve(true)
        }).catch(()=>{
          reject()
        })
      }
    })
  }

  hideGuidedTour() {
    setLocalStorageItem('re-import-api-intro-done','true');
    this.showGuidedTour = false;
    this.eventManager.emitShowGuidedTour(false);
  }

  deleteSelectedService($event: Event) {
    this.apiService.deleteEvent = $event;
    this.apiService._deleteSelectedService.next("deleteSelectedService");
  }

  openReimportAPIDialog() {
    if(this.showGuidedTour) {
      this.hideGuidedTour();
    }
    this.mixpanelService.track('reimport_step1');
    this.openDialogWithId('Re-importAPIModal')
  }
  openDialogWithId(id: string): void {
    this.dialogService.open(id)
  }





}
